import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  GetDnevniIzvestajMaloprodajaQuery,
  GetIzvestajPoArtiklimaMaloprodajaQuery,
  GetProdajaPoMagacinimaQuery,
  IDnevniIzvestajMaloprodajaFilter,
  IIzvestajiClient,
  IKorisnikAutocompleteDto,
  IMagacinDto,
  IMaloprodajaIzvestajDto,
  IzvestajiClient,
  MagaciniClient,
} from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { FormHelper } from '@kodit/core/form-definitions';
import { Store } from '@ngrx/store';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { VrstaIzvestajaMaloprodaja } from '../maloprodaja-page/maloprodaja-page-izvestaji.component';
import { MaloprodajaIzvestajService } from '../../maloprodaja-izvestaj.service';
import { AlertService, SharedService } from '@kodit/core/services';
import { finalize } from 'rxjs/operators';
import * as XLSX from 'xlsx';

@Component({
  selector: 'kodit-maloprodaja-filter-izvestaji',
  templateUrl: './maloprodaja-filter-izvestaji.component.html',
  styleUrls: ['./maloprodaja-filter-izvestaji.component.scss'],
})
export class MaloprodajaFilterIzvestajiComponent implements OnInit {
  @Input() tipIzvestaja: VrstaIzvestajaMaloprodaja;
  private _subs: Subscription = new Subscription();
  /**Props */
  filterData!: IDnevniIzvestajMaloprodajaFilter;
  form!: FormGroupTypeSafe<IDnevniIzvestajMaloprodajaFilter>;
  tableData: any;
  tip = VrstaIzvestajaMaloprodaja;
  kasir: string;
  private prethodniDatumOdBezVremena: string | null = null;
  private prethodniDatumDoBezVremena: string | null = null;
  magacinOptions: SelectItem[] = [];
  izabraniMagacinIds: number[] = [];

  constructor(
    private _fb: FormBuilderTypeSafe,
    private _formHelper: FormHelper,
    private _client: IzvestajiClient,
    private _magaciniClient: MagaciniClient,
    private _service: MaloprodajaIzvestajService,
    private _alertService: AlertService,
    private _sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.tipIzvestaja = VrstaIzvestajaMaloprodaja.DNEVNI_IZVESTAJ;
    this._service.setTip = this.tipIzvestaja;
    this.form = this.getForm(this.filterData);
    this._loadMagacini();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.tipIzvestaja = changes['tipIzvestaja'].currentValue.value;
    this._service.setTip = this.tipIzvestaja;
    this._resetValidators();
    if (this.form) {
      this._resetujFilter();
    }
    if (this.tipIzvestaja == VrstaIzvestajaMaloprodaja.PRODAJA_PO_MAGACINIMA) {
      this._postaviPodrazumevaneZaProdajuPoMagacinima();
    }
    this.prethodniDatumDoBezVremena = null;
    this.prethodniDatumOdBezVremena = null;
    this._service.setTableData = null;
  }

  public primeniFilter(): void {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    if (this.tipIzvestaja == VrstaIzvestajaMaloprodaja.PRODAJA_PO_MAGACINIMA) {
      this._primeniFilterProdajaPoMagacinima();
      return;
    }

    this._sharedService.displayLoadingScreen(true, 'Pribavljanje podataka...');

    const filter = {
      filteri: {
        datum: this.form.value.datum,
        datumOd: this.form.value.datumOd,
        datumDo: this.form.value.datumDo,
        kasirId: this.form.value.kasirId,
        jeOnlineProdaja:
          this.tipIzvestaja == VrstaIzvestajaMaloprodaja.ONLINE_PRODAJA,
      },
    };

    this._service.setFilter = this.form;

    if (this.tipIzvestaja == VrstaIzvestajaMaloprodaja.IZVESTAJ_PO_ARTIKLIMA) {
      this._subs.add(
        this._client
          .getIzvestajPoArtiklimaMaloprodaja(
            filter as GetIzvestajPoArtiklimaMaloprodajaQuery
          )
          .subscribe((result) => {
            if (result.succeeded) {
              setTimeout(() => {
                this._service.setTableData = result.data;
                this._sharedService.resetLoadingScreen();
              }, 420);
            } else {
              setTimeout(() => {
                this._service.setTableData = null;
                this._alertService.addWarnMsg(
                  'Za primenjeni filter nema podataka!'
                );
                this._sharedService.resetLoadingScreen();
              }, 420);
            }
          })
      );
    } else {
      this._subs.add(
        this._client
          .getDnevniIzvestajMaloprodaja(
            filter as GetDnevniIzvestajMaloprodajaQuery
          )
          .subscribe((result) => {
            if (result.succeeded) {
              setTimeout(() => {
                this._service.setTableData = result.data;
                this._sharedService.resetLoadingScreen();
              }, 420);
            } else {
              setTimeout(() => {
                this._service.setTableData = null;
                this._alertService.addWarnMsg(
                  'Za primenjeni filter nema podataka!'
                );
                this._sharedService.resetLoadingScreen();
              }, 420);
            }
          })
      );
    }
  }

  private _primeniFilterProdajaPoMagacinima(): void {
    const datumOd: Date = this.form.value.datumOd!;
    const datumDo: Date = this.form.value.datumDo!;

    if (new Date(datumOd) > new Date(datumDo)) {
      this._alertService.addFailedMsg('Datum od ne može biti posle datuma do.');
      return;
    }

    if (!this.izabraniMagacinIds?.length) {
      this._alertService.addFailedMsg('Izaberite bar jedan magacin.');
      return;
    }

    this._sharedService.displayLoadingScreen(true, 'Pribavljanje podataka...');

    const query = {
      datumOd: datumOd,
      datumDo: datumDo,
      magacinIds: [...this.izabraniMagacinIds],
    };

    this._service.setFilter = this.form;
    this._service.prodajaPoMagacinimaQuery = query;

    this._subs.add(
      this._client
        .getProdajaPoMagacinima(new GetProdajaPoMagacinimaQuery(query))
        .pipe(finalize(() => this._sharedService.resetLoadingScreen()))
        .subscribe((result) => {
          if (result.succeeded) {
            this._service.setTableData = result.data;
            return;
          }

          this._service.setTableData = null;
          this._alertService.addWarnMsg(
            result.messages?.[0] ?? 'Nema prodaje za izabrani period i magacine.'
          );
        })
    );
  }

  private _loadMagacini(): void {
    this._subs.add(
      this._magaciniClient.getMagaciniMultiselect().subscribe((res) => {
        this.magacinOptions = (res.data?.magacini ?? []).map(
          (x: IMagacinDto) => ({
            value: x.id,
            label: x.naziv,
          })
        );

        if (this.tipIzvestaja == VrstaIzvestajaMaloprodaja.PRODAJA_PO_MAGACINIMA) {
          this.izabraniMagacinIds = this.magacinOptions.map((x) => x.value);
        }
      })
    );
  }

  private _postaviPodrazumevaneZaProdajuPoMagacinima(): void {
    const danas = new Date();
    const pocetakGodine = new Date(danas.getFullYear(), 0, 1, 0, 0, 0, 0);
    const krajDanas = new Date(danas);
    krajDanas.setHours(23, 59, 59, 999);

    this.form?.controls.datumOd?.setValue(pocetakGodine);
    this.form?.controls.datumDo?.setValue(krajDanas);
    this.izabraniMagacinIds = this.magacinOptions.map((x) => x.value);
  }

  handleKorisnikChange(korisnik: IKorisnikAutocompleteDto) {
    this.form.controls.kasirId?.setValue(korisnik.id);
  }

  private _resetujFilter(): void {
    this.form.reset();
    if (this.tipIzvestaja == VrstaIzvestajaMaloprodaja.DNEVNI_IZVESTAJ) {
      this.form.controls.datum?.setValue(new Date());
    }
  }

  private _resetValidators(): void {
    this.form?.controls.datum?.clearValidators();
    this.form?.controls.datumOd?.clearValidators();
    this.form?.controls.datumDo?.clearValidators();

    if (this.tipIzvestaja == VrstaIzvestajaMaloprodaja.DNEVNI_IZVESTAJ) {
      this.form.controls.datum?.addValidators([Validators.required]);
    } else if (
      this.tipIzvestaja == VrstaIzvestajaMaloprodaja.PERIODICNI_IZVESTAJ ||
      this.tipIzvestaja == VrstaIzvestajaMaloprodaja.IZVESTAJ_PO_ARTIKLIMA ||
      this.tipIzvestaja == VrstaIzvestajaMaloprodaja.PERIODICNI_KASIR ||
      this.tipIzvestaja == VrstaIzvestajaMaloprodaja.ONLINE_PRODAJA ||
      this.tipIzvestaja == VrstaIzvestajaMaloprodaja.PRODAJA_PO_MAGACINIMA
    ) {
      this.form.controls.datumOd?.addValidators([Validators.required]);
      this.form.controls.datumDo?.addValidators([Validators.required]);
    }
    this.form?.updateValueAndValidity();
  }

  public onClear() {
    this.form?.controls.kasirId?.setValue(null);
  }

  onDatumOdChange(selectedDate: Date): void {
    if (!selectedDate) return;
    const selectedDateString = selectedDate.toDateString();
    if (this.prethodniDatumOdBezVremena !== selectedDateString) {
      const noviDatum = new Date(selectedDate);
      noviDatum.setHours(0, 0, 0, 0);
      this.form.controls.datumOd?.setValue(noviDatum);

      this.prethodniDatumOdBezVremena = selectedDateString;
    }
  }

  onDatumDoChange(selectedDate: Date): void {
    if (!selectedDate) return;
    const selectedDateString = selectedDate.toDateString();
    if (this.prethodniDatumDoBezVremena !== selectedDateString) {
      const noviDatum = new Date(selectedDate);
      noviDatum.setHours(23, 59, 59, 999);
      this.form.controls.datumDo?.setValue(noviDatum);

      this.prethodniDatumDoBezVremena = selectedDateString;
    }
  }

  private getForm(
    model?: IDnevniIzvestajMaloprodajaFilter
  ): FormGroupTypeSafe<IDnevniIzvestajMaloprodajaFilter> {
    return this._fb.group<IDnevniIzvestajMaloprodajaFilter>({
      datum: new FormControl(model?.datum! ?? new Date(), {
        validators: [Validators.required],
      }),
      datumOd: new FormControl(model?.datumOd!),
      datumDo: new FormControl(model?.datumDo!),
      kasirId: new FormControl(model?.kasirId!),
    });
  }
}
